const JBP_PLANNING = 'jbp-planning'

export const dataDisplaySettingsTranslations = {
  dataDisplayButton: `${JBP_PLANNING}-data-displaying-button`,
  dataDisplayHeader: `${JBP_PLANNING}-data-displaying-header`,
  newTableLayoutLookAndFeel: `${JBP_PLANNING}-new-table-layout-look-and-feel`,
  showHideQuarters: `${JBP_PLANNING}-show-hide-quarters`,
  showDetailed: `${JBP_PLANNING}-show-detailed`,
  yoy: {
    header: `${JBP_PLANNING}-show-yoy-header`,
    ava: `${JBP_PLANNING}-show-yoy-ava`,
    pva: `${JBP_PLANNING}-show-yoy-pva`,
    pvp: `${JBP_PLANNING}-show-yoy-pvp`,
    qva: `${JBP_PLANNING}-show-yoy-qva`,
    cvc: `${JBP_PLANNING}-show-yoy-cvc`,
  },
  qoq: {
    header: `${JBP_PLANNING}-show-qoq-header`,
    ava: `${JBP_PLANNING}-show-qoq-ava`,
    pva: `${JBP_PLANNING}-show-qoq-pva`,
    pvp: `${JBP_PLANNING}-show-qoq-pvp`,
    qva: `${JBP_PLANNING}-show-qoq-qva`,
    cvc: `${JBP_PLANNING}-show-qoq-cvc`,
  },
  achievements: {
    header: `${JBP_PLANNING}-show-achievements-header`,
    plan: `${JBP_PLANNING}-show-plan-achievement`,
    quota: `${JBP_PLANNING}-show-quota-achievement`,
  },
  additions: {
    header: `${JBP_PLANNING}-show-additions-header`,
    quotaTargets: `${JBP_PLANNING}-show-quota-targets`,
    actualsSplit: `${JBP_PLANNING}-show-actuals-split`,
    smbVsEuSplit: `${JBP_PLANNING}-show-smb-vs-eu-split`,
    partnerCount: `${JBP_PLANNING}-show-partner-count`,
  },
} as const
